import { SquareArrowOutUpRight } from 'lucide-react';
import type { ComponentPropsWithoutRef, ReactElement } from 'react';
import { cn } from '@/lib/utils';

type ExternalLinkProps = ComponentPropsWithoutRef<'a'> & {
  withIcon?: boolean;
  iconSize?: number;
};

export function ExternalLink({
  href,
  rel = 'noopener noreferrer',
  target = '_blank',
  className,
  children,
  withIcon = true,
  iconSize = 3,
  ...props
}: ExternalLinkProps): ReactElement {
  return (
    <a
      className={cn('inline-flex items-center gap-1', className)}
      href={href}
      rel={rel}
      target={target}
      {...props}
    >
      {children}
      {withIcon && (
        <SquareArrowOutUpRight
          aria-hidden
          className={`size-${iconSize} shrink-0`}
        />
      )}
    </a>
  );
}
